import { FC, useMemo } from "react";
import TableComponent, {
  TableProps,
} from "../../../../../../common/components/table/table.component";
import uuidService from "../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../context/app.context";
import OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableComponent from "./driver/order-optimizer-taxi-details-hidden-details-heading-tables-driver-table.component";
import orderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableHelper from "./order-optimizer-taxi-details-hidden-details-center-tables.helper";
import OrderOptimizerTaxiDetailsHiddenDetailsTablesOrdersComponent from "./orders/order-optimizer-taxi-details-hidden-details-center-tables-orders.component";
import OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableRow from "./types/order-optimizer-taxi-details-hidden-details-center-tables-table-row";
import {
  OrderOptimizerTaxiDetailsItemDriver,
  OrderOptimizerTaxiDetailsItemOrders,
  OrderOptimizerTaxiDetailsItemStepsOrders,
} from "../../common/types/order-optimizer-taxi-details-item";

type OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableProps = Pick<
  TableProps,
  "isError" | "isLoading"
> & {
  driver: OrderOptimizerTaxiDetailsItemDriver | null;
  orders: OrderOptimizerTaxiDetailsItemOrders[];
  ordersSteps: OrderOptimizerTaxiDetailsItemStepsOrders[];
};

const OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableComponent: FC<
  OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const allStepPoints = useMemo(() => {
    return props.ordersSteps.map((step) => step.points).flat();
  }, [props.ordersSteps]);

  const stepOffsets: number[] = useMemo(() => {
    const offsets: number[] = [];
    let totalOffset = 0;

    props.ordersSteps.forEach((steps) => {
      offsets.push(totalOffset);
      totalOffset += steps.points.length;
    });

    return offsets;
  }, [props.ordersSteps]);

  const createTableRow = (
    order: OrderOptimizerTaxiDetailsItemOrders,
    steps: OrderOptimizerTaxiDetailsItemStepsOrders,
    stepOffset: number,
    orderIndex: number
  ): OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableRow => {
    return {
      id: uuidService.generate(),
      value: {
        orders: (
          <div className="order_optimizer_taxi_details_hidden_details_center_tables_order">
            <OrderOptimizerTaxiDetailsHiddenDetailsTablesOrdersComponent
              allStepPoints={allStepPoints}
              order={order}
              step={steps}
              stepOffset={stepOffset}
              orderIndex={orderIndex}
              driver={props.driver}
            />
          </div>
        ),
        driver: (
          <div className="order_optimizer_taxi_details_hidden_details_center_tables_driver">
            <OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableComponent
              detailsStepsOrdersPointsItems={steps.points}
            />
          </div>
        ),
      },
    };
  };

  const rows: OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableRow[] =
    useMemo(() => {
      return props.orders.map((order, orderIndex) =>
        createTableRow(
          order,
          props.ordersSteps[orderIndex],
          stepOffsets[orderIndex],
          orderIndex
        )
      );
    }, [props.orders, props.ordersSteps, stepOffsets, selectedAppLanguage]);

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
      noHeader
    />
  );
};

export default OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesTableComponent;
